import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SecurityContext,
  SimpleChange,
} from '@angular/core';
import {
  TranslationService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core';
import { Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { take } from 'rxjs/operators';
import {
  testRegex,
  REGULAR_PATTERN,
} from '../../../../../core/generic-validator/regular-expressions';
import { FileProgressLayouts } from '../../../../../shared/models/fileSize.model';
import { CheckoutDetailModel } from '../../../../checkout/buy-checkout/buy-checkout.model';
import { GuestBuyCheckoutService } from '../../../../checkout/guest-checkout/services/guest-buy-checkout.service';
import { SharedCartService } from '../../../../cart/cart-shared/shared-cart.service';

@Component({
  standalone: false,
  selector: 'app-waygate-notifications-attachments',
  templateUrl: './waygate-notifications-attachments.component.html',
  styleUrls: ['./waygate-notifications-attachments.component.scss'],
})
export class WaygateNotificationsAttachmentsComponent {
  @Output() setNotificationData: EventEmitter<any> = new EventEmitter();
  @Output() checkNotificationVal: EventEmitter<any> = new EventEmitter();
  @Input() rmaInvoiceMail;
  @Input() orderAckMail;
  @Input() invoiceName;
  @Input() invoicePhone;
  @Input() orderAckName;
  @Input() orderAckPhone;
  @Input() isQuote;
  @Input() isChinaOrder: boolean;
  @Input() endUserAddress;
  @Input() soldAddress;
  forChinaApac: boolean = false;
  invoiceCheck: boolean;
  $subscription: Subscription;
  invoiceContactName: any = '';
  invoiceContactNo: any = '';
  invoiceMail: any = '';
  orderAckContactName: any = '';
  orderAckContactNo: any = '';
  orderAck: any = '';
  reason: any = '';
  shippingCheck: boolean;
  error = {
    invoiceMail: '',
    orderAck: '',
    reason: '',
    reasonMsg: '',
    orderAckContactName: '',
    orderAckContactNo: '',
    invoiceContactName: '',
    invoiceContactNo: '',
  };

  bhgeReview: string = 'true';
  checkoutDetailModel: CheckoutDetailModel;
  readonly ALLOWED_EXTENSIONS = ['jpg', 'pdf'];
  showIcon: boolean = true;
  readonly layouts = FileProgressLayouts;
  files = [];
  fileName: string;
  uploadParams = {
    entryNumber: 1,
    fields: 'DEFAULT',
    returnLocation: 'DEFAULT',
  };
  deleteParams = {
    returnLocation: 'DEFAULT',
  };
  cartId;
  uploadUrl;
  deletUrl;

  checkoutMessages: any;

  constructor(
    private chkService: GuestBuyCheckoutService,
    private activeCartFacade: ActiveCartFacade,
    private translate: TranslationService,
    private globalMessageService: GlobalMessageService,
    private sharedCartService: SharedCartService,
    public sanitizer: DomSanitizer
  ) {
    this.checkoutDetailModel = new CheckoutDetailModel();
  }

  ngOnInit(): void {
    this.getCartId();
    this.chkService.getValidation().subscribe((notification) => {
      if (notification) {
        this.onSubmit();
      }
    });
    this.bhgeReview = 'false';
    if (this.isChinaOrder) {
      this.bhgeReview = 'true';
    }
    this.onload();
  }
  getPlaceholder() {
    return this.forChinaApac
      ? this.getTranslatedText('labels.placeholderForChinaReview')
      : '';
  }
  ngOnChanges(changes: SimpleChange) {
    if (
      this.rmaInvoiceMail ||
      this.orderAckMail ||
      this.invoiceName ||
      this.invoicePhone ||
      this.orderAckPhone ||
      this.orderAckName
    ) {
      this.orderAck = this.orderAckMail;
      this.invoiceMail = this.rmaInvoiceMail;
      this.invoiceContactName = this.invoiceName;
      this.orderAckContactName = this.orderAckName;
      this.invoiceContactNo = this.invoicePhone;
      this.orderAckContactNo = this.orderAckPhone;
    }
    const currentEnd =
      changes['endUserAddress'] && changes['endUserAddress'].currentValue;
    if (this.isChinaOrder)
      if (currentEnd && currentEnd.formattedAddress) {
        const isEndSoldSame =
          currentEnd.formattedAddress === this.soldAddress.formattedAddress;
        if (isEndSoldSame) {
          this.forChinaApac = false;
          setTimeout(() => {
            this.bhgeReview = 'false';
          }, 100);
        } else {
          this.forChinaApac = true;
          setTimeout(() => {
            this.bhgeReview = 'true';
          }, 100);
        }
      } else {
        this.forChinaApac = true;
        setTimeout(() => {
          this.bhgeReview = 'true';
        }, 100);
      }
  }

  getTranslatedText(key) {
    let message;
    this.translate.translate(key).subscribe((res: any) => {
      message = res;
    });
    return message;
  }

  getCartId() {
    this.activeCartFacade.getActiveCartId().subscribe((cartId) => {
      this.cartId = cartId;
      if (this.cartId) {
        this.uploadUrl =
          'users/current/dscheckout/' +
          this.cartId +
          '/false/uploadOrderAttachment';
        this.deletUrl =
          'users/current/dscheckout/' +
          this.cartId +
          '/false/removeOrderAttach';
      }
    });
  }

  onSubmit() {
    if (!this.orderAckContactName) {
      this.error.orderAckContactName = this.getTranslatedText(
        'errors.orderAckContactName'
      );
      // window.scrollTo({ top: 1200, behavior: 'smooth' });
    }
    if (!this.orderAckContactNo) {
      this.error.orderAckContactNo = this.getTranslatedText(
        'errors.orderAckContactNo'
      );
      // window.scrollTo({ top: 1200, behavior: 'smooth' });
    }
    if (!this.invoiceContactName) {
      this.checkoutDetailModel.invoiceContact = '';
      this.error.invoiceContactName = this.getTranslatedText(
        'errors.invoiceContactName'
      );
      // window.scrollTo({ top: 1200, behavior: 'smooth' });
    }
    if (!this.invoiceContactNo) {
      this.checkoutDetailModel.invoicePhone = '';
      this.error.invoiceContactNo = this.getTranslatedText(
        'errors.invoiceContactNo'
      );
      // window.scrollTo({ top: 1200, behavior: 'smooth' });
    }
    if (!this.invoiceMail) {
      this.checkoutDetailModel.invEmail = '';
      this.error.invoiceMail = this.getTranslatedText('errors.invoiceMail');
      // window.scrollTo({ top: 1200, behavior: 'smooth' });
    }
    if (!this.orderAck) {
      this.error.orderAck = this.getTranslatedText('errors.orderAck');
      // window.scrollTo({ top: 1200, behavior: 'smooth' });
    }
    if (!this.reason && this.bhgeReview == 'true' && !this.forChinaApac) {
      this.error.reasonMsg = this.getTranslatedText('errors.reasonMsg');
      return;
      // window.scrollTo({ top: 1300, behavior: 'smooth' });
    } else this.error.reasonMsg = '';

    if (this.error.invoiceContactNo) {
      // window.scrollTo({ top: 1200, behavior: 'smooth' });
      this.checkNotificationVal.emit(false);
      return;
    } else {
      this.checkNotificationVal.emit(true);
      this.notificationData();
    }

    if (this.error.orderAckContactNo) {
      // window.scrollTo({ top: 1200, behavior: 'smooth' });
      this.checkNotificationVal.emit(false);
      return;
    } else {
      this.checkNotificationVal.emit(true);
      this.notificationData();
    }

    if (this.error.orderAck) {
      // window.scrollTo({ top: 1200, behavior: 'smooth' });
      this.checkNotificationVal.emit(false);
      return;
    } else {
      this.checkNotificationVal.emit(true);
      this.notificationData();
    }

    if (this.error.invoiceMail) {
      // window.scrollTo({ top: 1200, behavior: 'smooth' });
      this.checkNotificationVal.emit(false);
      return;
    } else {
      this.checkNotificationVal.emit(true);
      this.notificationData();
    }

    if (this.bhgeReview == 'true') {
      if (
        this.orderAck &&
        this.invoiceMail &&
        this.reason &&
        this.invoiceContactName &&
        this.invoiceContactNo &&
        this.orderAckContactName &&
        this.orderAckContactNo
      ) {
        this.checkoutDetailModel.invEmail = this.invoiceMail
          ?.trim()
          ?.toLowerCase();
        this.checkoutDetailModel.orderAckMail = this.orderAck
          ?.trim()
          ?.toLowerCase();
        this.checkoutDetailModel.reason = this.reason?.trim();
        this.checkoutDetailModel.bhgeReview = this.bhgeReview?.trim();
        this.checkoutDetailModel.invoiceContact =
          this.invoiceContactName?.trim();
        this.checkoutDetailModel.invoicePhone = this.invoiceContactNo?.trim();
        this.checkoutDetailModel.soaContact = this.orderAckContactName?.trim();
        this.checkoutDetailModel.soaPhone = this.orderAckContactNo?.trim();
        if (this.forChinaApac) {
          this.checkoutDetailModel.reason =
            this.getTranslatedText('waygate.chinaCSRReason') +
            this.reason?.trim();
        }
        this.setNotificationData.emit(this.checkoutDetailModel);
      }
    } else {
      if (
        this.orderAck &&
        this.invoiceMail &&
        this.invoiceContactName &&
        this.invoiceContactNo &&
        this.orderAckContactName &&
        this.orderAckContactNo
      ) {
        this.checkoutDetailModel.invEmail = this.invoiceMail
          ?.trim()
          ?.toLowerCase();
        this.checkoutDetailModel.orderAckMail = this.orderAck
          ?.trim()
          ?.toLowerCase();
        this.checkoutDetailModel.reason = this.reason
          ? this.reason?.trim()
          : '';
        this.checkoutDetailModel.bhgeReview = this.bhgeReview?.trim();
        this.checkoutDetailModel.invoiceContact =
          this.invoiceContactName?.trim();
        this.checkoutDetailModel.invoicePhone = this.invoiceContactNo?.trim();
        this.checkoutDetailModel.soaContact = this.orderAckContactName?.trim();
        this.checkoutDetailModel.soaPhone = this.orderAckContactNo?.trim();
        if (this.forChinaApac) {
          this.checkoutDetailModel.reason =
            this.getTranslatedText('waygate.chinaCSRReason') + this.reason
              ? this.reason?.trim()
              : '';
        }
        this.setNotificationData.emit(this.checkoutDetailModel);
      }
    }
  }

  handleChange(e) {
    this.bhgeReview = e.target.value;
    if (this.bhgeReview == 'false') {
      this.reason = '';
      this.error.reasonMsg = '';
      this.checkNotificationVal.emit(true);
      this.notificationData();
    } else if (this.bhgeReview == 'true' && !this.reason) {
      this.error.reasonMsg = this.getTranslatedText('errors.reasonMsg');
      this.checkNotificationVal.emit(false);
      this.notificationData();
    } else {
      this.reason = '';
      this.checkNotificationVal.emit(true);
      this.notificationData();
    }

    // this.globalMessageService.add(
    //   "Choosing 'YES' will have Baker Hughes review your order before it is sent for processing. This may slow down your order. Pricing charges may apply, depending on your request.",
    //   GlobalMessageType.MSG_TYPE_WARNING,
    //   0
    // );
  }

  onChange(e?, field?) {
    if (field === 'shippingCheck') {
      this.shippingCheck = e.target.checked;
      if (this.shippingCheck) {
        this.sharedCartService.shippingContactDetails
          .pipe(take(1))
          .subscribe((details) => {
            this.orderAckContactName = details.ShipName;
            this.orderAckContactNo = details.shipContact;
            this.orderAck = details.shipNotimail;
            this.error.orderAckContactName = '';
            this.error.orderAckContactNo = '';
            this.error.orderAck = '';
          });
      } else {
        this.orderAckContactName = '';
        this.orderAckContactNo = '';
        this.orderAck = '';
      }
    }
    if (field === 'invoiceCheck') {
      if (e.target.checked == true) {
        this.invoiceContactName = this.orderAckContactName;
        this.invoiceContactNo = this.orderAckContactNo;
        this.invoiceMail = this.orderAck;
        this.error.invoiceContactName = '';
        this.error.invoiceContactNo = '';
        this.error.invoiceMail = '';
      } else {
        this.invoiceContactName = '';
        this.invoiceContactNo = '';
        this.invoiceMail = '';
      }
    }
    if (field === 'orderAckContactName') {
      this.error.orderAckContactName = '';
      this.orderAckContactName = e.target.value;
      const pattern = /^[\wÁ-ÿa-zA-Z0-9.+-/%,;() ]+$/;
      if (e.target.value && !e.target.value.match(pattern)) {
        this.error.orderAckContactName = this.getTranslatedText(
          'errors.orderAckContactName'
        );
      } else this.error.orderAckContactName = '';
    }
    if (field === 'orderAckContactNo') {
      this.error.orderAckContactNo = '';
      this.orderAckContactNo = e.target.value;
      const pattern = REGULAR_PATTERN.phoneNumberRegex;
      if (e.target.value && !e.target.value.match(pattern)) {
        this.error.orderAckContactNo = this.getTranslatedText(
          'errors.contactNoInvalid'
        );
      } else this.error.orderAckContactNo = '';
    }
    if (field === 'invoiceContactName') {
      this.error.invoiceContactName = '';
      this.invoiceContactName = e.target.value;
      const pattern = /^[\wÁ-ÿa-zA-Z0-9.+-/%,;() ]+$/;
      if (e.target.value && !e.target.value.match(pattern)) {
        this.error.invoiceContactName = this.getTranslatedText(
          'errors.invoiceContactName'
        );
      } else this.error.invoiceContactName = '';
    }
    if (field === 'invoiceContactNo') {
      this.error.invoiceContactNo = '';
      this.checkoutDetailModel.invoicePhone = e.target.value;
      this.invoiceContactNo = e.target.value;
      const pattern = REGULAR_PATTERN.phoneNumberRegex;
      if (e.target.value && !e.target.value.match(pattern)) {
        this.error.invoiceContactNo = this.getTranslatedText(
          'errors.contactNoInvalid'
        );
      } else {
        this.error.invoiceContactNo = '';
      }
    }
    if (field === 'orderAck') {
      this.error.orderAck = '';
      this.orderAck = e.target.value;
      const emailRegx = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';
      if (e.target.value && !e.target.value.match(emailRegx)) {
        this.error.orderAck = this.getTranslatedText('errors.emailInvalid');
      } else {
        this.error.orderAck = '';
      }
    }
    if (field === 'invoiceMail') {
      this.error.invoiceMail = '';
      this.invoiceMail = e.target.value;
      this.checkoutDetailModel.invEmail = e.target.value;
      const emailRegx = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';
      if (e.target.value && !e.target.value.match(emailRegx)) {
        this.error.invoiceMail = this.getTranslatedText('errors.emailInvalid');
      } else {
        this.error.invoiceMail = '';
      }
    }
    if (field === 'reason' && !this.forChinaApac) {
      if (this.bhgeReview == 'false') {
        this.reason = '';
      } else {
        this.error.reasonMsg = '';
        this.reason = e.target.value;
        this.validateInput(this.reason);
        this.checkoutDetailModel.reason = this.reason;
      }
      if (!this.reason)
        this.error.reasonMsg = this.getTranslatedText('errors.reasonMsg');
      else this.error.reasonMsg = '';
    }
    this.checkNotificationValid();
  }
  checkNotificationValid() {
    if (
      this.orderAckContactName &&
      this.orderAckContactNo &&
      this.orderAck &&
      this.invoiceContactName &&
      this.invoiceContactNo &&
      this.invoiceMail &&
      !this.error.orderAckContactName &&
      !this.error.orderAckContactNo &&
      !this.error.orderAck &&
      !this.error.invoiceContactName &&
      !this.error.invoiceContactNo &&
      !this.error.invoiceMail &&
      !this.error.reasonMsg
    ) {
      this.checkNotificationVal.emit(true);
      this.notificationData();
    } else {
      this.checkNotificationVal.emit(false);
    }
  }

  selectedFiles(event) {
    this.files = event;
  }

  deletedFiles(event) {
    if (this.files.indexOf(event) > -1) {
      this.files.splice(this.files.indexOf(event), 1);
    }
  }

  ngOnDestroy() {
    this.chkService.setValidation(false);
  }

  onload() {
    this.error = {
      invoiceMail: '',
      orderAck: '',
      reason: '',
      reasonMsg: '',
      orderAckContactName: '',
      orderAckContactNo: '',
      invoiceContactName: '',
      invoiceContactNo: '',
    };
    const pattern = REGULAR_PATTERN.phoneNumberRegex;
    var emailRegx = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';
    this.checkoutDetailModel.soaContact = testRegex(
      this.sanitizer.sanitize(SecurityContext.HTML, this.orderAckContactName),
      REGULAR_PATTERN.alphaNumeric
    );

    if (this.orderAckContactNo && !this.orderAckContactNo.match(pattern)) {
      this.error.orderAckContactNo = this.getTranslatedText(
        'errors.contactNoInvalid'
      );
    } else this.error.orderAckContactNo = '';

    this.checkoutDetailModel.invoiceContact = testRegex(
      this.sanitizer.sanitize(SecurityContext.HTML, this.invoiceContactName),
      REGULAR_PATTERN.alphaNumeric
    );

    if (this.orderAckContactNo && !this.orderAckContactNo.match(pattern)) {
      this.error.orderAckContactNo = this.getTranslatedText(
        'errors.contactNoInvalid'
      );
    } else this.error.orderAckContactNo = '';

    this.checkoutDetailModel.invoiceContact = testRegex(
      this.sanitizer.sanitize(SecurityContext.HTML, this.invoiceContactName),
      REGULAR_PATTERN.alphaNumeric
    );

    if (this.bhgeReview == 'true' && !this.forChinaApac) {
      this.reason = testRegex(
        this.sanitizer.sanitize(SecurityContext.HTML, this.reason),
        REGULAR_PATTERN.alphaNumeric
      );
      if (!this.reason)
        this.error.reasonMsg = this.getTranslatedText('errors.reasonMsg');
      else this.error.reasonMsg = '';
    }
    this.checkNotificationValid();
  }

  notificationData() {
    this.checkoutDetailModel.invEmail = this.invoiceMail?.trim().toLowerCase();
    this.checkoutDetailModel.orderAckMail = this.orderAck?.trim().toLowerCase();
    this.checkoutDetailModel.reason = this.reason?.trim();
    this.checkoutDetailModel.bhgeReview = this.bhgeReview?.trim();
    this.checkoutDetailModel.invoiceContact = this.invoiceContactName?.trim();
    this.checkoutDetailModel.invoicePhone = this.invoiceContactNo?.trim();
    this.checkoutDetailModel.soaContact = this.orderAckContactName?.trim();
    this.checkoutDetailModel.soaPhone = this.orderAckContactNo?.trim();
    if (this.forChinaApac) {
      this.checkoutDetailModel.reason =
        this.getTranslatedText('waygate.chinaCSRReason') + this.reason?.trim();
    }
    this.setNotificationData.emit(this.checkoutDetailModel);
  }

  validateInput(reason: string) {
    const reasonPattern = /^[\w\sÁ-ÿ.+-/%,;() ]+$/m;
    const lines = reason.split('\n');
    if (lines.length > 0) {
      lines?.forEach((item) => {
        console.log('item', item);
        if (item && !item?.match(reasonPattern)) {
          this.reason = '';
        }
      });
    }
  }
}
